import firebase from "./firebase";
import fb from "firebase/app";

const firestore = firebase.firestore();

export const getDetailClient = async (id) =>
  await firestore
    .collection("companies")
    .doc(id)
    .get();

export const updateCompany = async (id, data) => {
  const cleanData = Object.fromEntries(
    Object.entries(data).filter(
      ([_, value]) => value !== undefined && value !== null
    )
  );

  await firestore
    .collection("companies")
    .doc(id)
    .update({
      ...cleanData,
      updatedAt: fb.firestore.FieldValue.serverTimestamp(),
    });
};
